import * as Yup from "yup";
import validationUtils from "./ValidationUtils.js";

const contactUsSchema = Yup.object().shape({
  first_name: validationUtils?.validateName("first_name"),

  last_name: validationUtils?.validateName("last_name"),

  email: validationUtils?.validateEmail(),

  subject: validationUtils?.validateMessage("subject"),

  message: validationUtils?.validateMessage("message"),
});

export default contactUsSchema;
